import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges} from '@angular/core';
import {MenuItem, TreeNode} from "primeng/api";
import {AutoCompleteCompleteEvent, AutoCompleteSelectEvent} from "primeng/autocomplete";
import {
    DcPageContentSearchResponse,
    DcPageSearchResult
} from "../../../model/dto/entity/dc-page-content-search-response.dto";
import {DcPageContentService} from "../../../service/dc-page-content.service";
import {ActivatedRoute, Router} from '@angular/router';
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {DcPageContentDto} from "../../../model/dto/entity/dc-page-content.dto";
import {DmDocumentService} from "../../../../../feature-core/dm/service/api/dm-document.service";
import {MvsMessageService} from "../../../../../core/shared/service/message/mvs-message.service";
import {QuillHelper} from "../../../../../core/shared/helper/quill-helper";
import {DcPageContentDisplayModeResponseDto} from "../../../model/dto/entity/dc-meta-reference.dto";
import {
    QuillTagClickEvent
} from "../../../../../core/shared/form/field/output/mvs-form-field-quill-editor/mvs-form-field-output-quill-editor.component";
import {MetaDataEntityDto} from "../../../../../core/shared/meta/dto/meta-data-entity.dto";
import {MetaService} from "../../../../../core/shared/meta/service/meta.service";
import {MetaDataJoinDto} from "../../../../../core/shared/meta/dto/meta-data-join.dto";
import {MvsObjectNavigationService} from "../../../../../core/shared/navigation/mvs-object-navigation.service";

//DEPRECATED//
// NOT_IN_USE_CURRENTLY
@Component({
    selector: 'dc-page-content',
    templateUrl: 'dc-page-content.component.html',
    styleUrls: ['dc-page-content.component.scss'],
    standalone: false
})
export class DcPageContentComponent implements OnInit, OnChanges, OnDestroy {

    busy: boolean;  // indicator whether the component is busy
    initialized: boolean; // indicator whether the component was initialized

    suggestions: DcPageSearchResult[] = [];
    breadCrumb: MenuItem[];
    value: any;
    isSearchCurrentDirectory: boolean;
    quillForm: FormGroup;
    // readOnly: boolean = true;
    contentDto: DcPageContentDisplayModeResponseDto;

    showSearch: boolean;

    listenerTags: string[] = ['entity-link', 'attr-link'];

    selectedEntity: MetaDataEntityDto;
    showSideBar: boolean = false;
    metaMap = new Map<number, MetaDataEntityDto>();
    sectionName: string;

    @Input() currentIndex: number;
    @Input() totalSections: number;

    @Output() editorModeChange = new EventEmitter<'read' | 'edit'>();

    @Input() hierarchyTree: TreeNode[];
    @Input() selectedNode: TreeNode<DcPageContentDto>;
    @Output() selectedNodeChange: EventEmitter<TreeNode> = new EventEmitter<TreeNode>();

    editorTypeList: any[] = [{label: 'Edit', value: 'edit', icon: 'fa-solid fa-pen-to-square'},
        {label: 'Read', value: 'read', icon: 'fa-brands fa-readme'}];
    editorMode: 'read' | 'edit' = 'read';

    constructor(
        protected dcPageContentService: DcPageContentService,
        protected messageService: MvsMessageService,
        protected router: Router,
        protected route: ActivatedRoute,
        protected fb: FormBuilder,
        protected metaService: MetaService,
        protected navigationService: MvsObjectNavigationService,
        protected documentService: DmDocumentService) {
    }

    ngOnInit(): void {
        this.initComponent();

    }

    /**
     * Initialize Component.
     */
    initComponent() {
        this.refreshComponent();
    }

    /**
     * Refresh Component.
     */
    refreshComponent() {

        if (this.selectedNode?.type != 'content' && this.selectedNode?.type != 'newContent') {
            this.initialized = true;
            return;
        }

        this.createForm();
        this.getContent();

        if (this.selectedNode?.type == 'content') {
            this.editorMode = 'read';
        } else if (this.selectedNode?.type == 'newContent') {
            this.editorMode = 'edit';
        }
        this.editorModeChange.emit(this.editorMode);
        this.breadCrumb = this.createBreadCrumb(this.selectedNode?.key, undefined, 1);

    }

    getContent() {
        this.dcPageContentService.getContentById(this.selectedNode.data.id).subscribe((content: DcPageContentDisplayModeResponseDto) => {
            this.contentDto = content;
            this.loadContent();
            this.setSectionName();

        }),
            (error => {
                console.error('error', error)
            }),
            (finalize => this.busy = false);
    }

    createForm() {
        this.quillForm = this.fb.group({
            editorContent: new FormControl('', [Validators.required])
        });
    }

    setSectionName() {
        if (!this.selectedNode) {
            return;
        }

        this.sectionName = this.selectedNode.data.sectionDtoName;

        // if (!this.sectionName || this.sectionName == '') {
        //     this.sectionName = 'Content';
        // }

    }


    loadContent() {
        this.busy = true;
        let content = null;

        if (this.editorMode == 'read') {
            content = this.contentDto.readModeText;
        } else {
            content = this.contentDto.documentText;
        }

        if (!content) {
            content = this.contentDto.documentText;
        }

        if (this.editorMode == 'read') {
            content = this.transformMentionsForViewMode(this.contentDto.readModeText);
        }

        QuillHelper.loadContent(content, this.documentService).subscribe(res => {
            this.selectedNode.data.content = res;
            this.quillForm.setValue({editorContent: res});

            this.initialized = true;
            this.busy = false;
        }),
            (error => {
                this.initialized = true;
                this.busy = false;
            }),
            (finalize => this.busy = false);
    }

    handleModeChange() {
        this.editorModeChange.emit(this.editorMode);
        this.loadContent();
    }

    transformMentionsForViewMode(html: string): string {
        const container = document.createElement('div');
        container.innerHTML = html;

        const mentions = container.querySelectorAll('.mention');

        mentions.forEach(m => {
            const full = m.getAttribute('data-full-text');
            const alias = m.getAttribute('data-value');

            if (!full || !alias) return;

            const [meta, entity, attribute] = full.split(':');

            const link = document.createElement('a');
            link.classList.add('meta-link');

            if (!attribute) {
                link.classList.add('entity-link');
                link.textContent = entity.split('.').pop();
                link.dataset.alias = entity;
            } else {
                link.classList.add('attr-link');
                link.textContent = attribute;
                link.dataset.alias = entity;
                link.dataset.attr = attribute;
            }

            m.replaceWith(link);
        });

        return container.innerHTML;
    }

    onEntityClick(alias: string) {

        const metaReference = this.contentDto.metaEntities.find(item => item.objectTypeAlias == alias);

        if (!metaReference) {
            return;
        }

        this.selectedEntity = metaReference;

    }

    onAttributeClick(alias: string, attribute: string) {
        const metaReference = this.contentDto.metaEntities.find(item => item.objectTypeAlias == alias);

        if (!metaReference) {
            return;
        }

        //check if it's an attribute or a join
        let isAttribute: boolean

        for (let item of metaReference.attributes) {

            if (item.attributeName == attribute) {
                isAttribute = true;
                break;
            }
        }

        if (isAttribute) {
            // directly show parent entity
            this.selectedEntity = metaReference;

        } else {
            //look for join
            let selectedJoin: MetaDataJoinDto = null;
            for (let item of metaReference.joins) {
                if (item.name == attribute) {
                    selectedJoin = item;
                    break;
                }
            }

            if (selectedJoin) {

                //check for map if exists

                const existingObject = this.metaMap.get(selectedJoin.joinObjectTypeId);

                if (existingObject) {
                    this.selectedEntity = existingObject;
                } else {
                    //otherwise API call
                    this.metaService.getById(selectedJoin.joinObjectTypeId, true, true).subscribe(res => {
                        this.selectedEntity = res;
                    });

                }


            }
        }


    }


    search(event: AutoCompleteCompleteEvent) {
        if (this.isSearchCurrentDirectory && this.selectedNode) {
            this.dcPageContentService.searchContentByPage(Number(this.selectedNode.key), event.query).subscribe((result: DcPageContentSearchResponse) => {
                if (result.results && result.results.length > 0) {
                    this.suggestions = [...result.results];
                } else {
                    this.suggestions = [];
                }
            });
        } else {
            this.dcPageContentService.searchContent(event.query).subscribe((result: DcPageContentSearchResponse) => {
                if (result.results && result.results.length > 0) {
                    this.suggestions = [...result.results];
                } else {
                    this.suggestions = [];
                }
            });
        }

    }

    selectContent(event: AutoCompleteSelectEvent) {
        if (event.value) {
            if (event.value.pageDtoId) {
                const pageId = event.value.pageDtoId;

                let shouldUpdate: boolean;

                if (this.isSearchCurrentDirectory && this.selectedNode) {
                    shouldUpdate = true;
                } else {
                    shouldUpdate = false;
                }

                this.breadCrumb = this.createBreadCrumb(pageId.toString());
                this.router.navigate([], {
                    relativeTo: this.route,
                    queryParams: {
                        page: event.value.pageDtoId,
                        content: event.value.id,
                        update: shouldUpdate
                    },
                    queryParamsHandling: 'merge' // if you want to keep existing query params
                });
            }
        }
    }


    createBreadCrumb(pageId: string, hierarchyTree: TreeNode[] = this.hierarchyTree, level?: number): { label: string }[] | null {

        for (const node of hierarchyTree) {
            if (node.key === pageId) {

                return [{label: node.label}];
            }
            if (node.children && node.children.length > 0) {
                const childPath = this.createBreadCrumb(pageId, node.children, level);
                if (childPath) {
                    const fullPath = [{label: node.label}, ...childPath];
                    if (level !== undefined) {
                        return fullPath.slice(-1 - level); // Includes `level` parents + current node
                    }
                    return fullPath;
                }
            }
        }
        return null;
    }

    updatePageContent() {

        if (this.busy) {
            return;
        }

        this.busy = true;

        const dto = new DcPageContentDto();

        dto.id = this.selectedNode.data.id;
        dto.content = this.quillForm.get('editorContent')?.value;

        this.dcPageContentService.updatePageContent(dto.id, dto.content).subscribe(res => {
            this.selectedNode.data.content = this.quillForm.get('editorContent')?.value;
            this.messageService.showSuccessMessage('Update', 'Content Updated Successfully');

            if (this.selectedNode.type === 'newContent') {
                this.selectedNode.type = 'content'
                this.selectedNodeChange.emit(this.selectedNode);
            }

            // if (!this.contentDto) {
            this.contentDto = res;
            // }


            this.editorMode = 'read';
            this.editorModeChange.emit(this.editorMode);
            this.loadContent();
        }, error => {
            this.busy = false;
        });

    }

    saveBtnDisabled(): boolean {
        return !this.quillForm?.get('editorContent').value || this.busy;
    }

    /**
     * Process changes within Binding.
     * @param changes
     */
    ngOnChanges(changes: SimpleChanges): void {
        if (!this.initialized) {
            return;
        }

        if (changes['selectedNode'] && changes['selectedNode'] !== undefined) {
            this.refreshComponent();
        }

    }

    handleDirectory() {
        this.isSearchCurrentDirectory = !this.isSearchCurrentDirectory;
    }

    handleSearch() {
        this.showSearch = !this.showSearch;
    }

    handleMentionClick(event: Event) {
        const target = event.target as HTMLElement;

        // Only handle clicks on our link elements
        if (target.classList.contains('meta-link')) {
            this.handleQuillTagClick(target.dataset);
        }
    }

    handleQuillTagClick(dataset: QuillTagClickEvent) {
        if (dataset['alias'] && dataset['attr']) {
            //attribute
            this.onAttributeClick(dataset['alias'], dataset['attr']);

        } else {
            //entity
            this.onEntityClick(dataset['alias'])
        }
    }

    handleHideSidebar() {
        this.selectedEntity = null;
    }

    /**
     * Destroy component.
     */
    ngOnDestroy(): void {

    }


}
